import type { SxProps, Theme } from '@mui/material';

export const lessonStepClassNames = {
  root: 'skill-step',
  marker: 'skill-step-marker',
  content: 'skill-step-content',
  status: 'skill-step-status',
  titleParagraph: 'skill-step-title-paragraph',
  titleStrong: 'skill-step-title-strong',
};

export const lessonStepStyles = {
  root: (theme: Theme) =>
    ({
      display: 'grid',
      gridTemplateColumns: '52px minmax(0, 1fr) 136px',
      gap: 0,
      alignItems: 'stretch',
      minWidth: 0,
      minHeight: 0,
      background: 'transparent',
      '&.MuiPaper-root': {
        background: 'transparent',
      },
      '&:first-of-type .skill-step-content': {
        display: 'grid',
        gridTemplateRows: 'auto minmax(0, 1fr) auto auto',
        alignContent: 'stretch',
      },
      [theme.breakpoints.down(980)]: {
        gridTemplateColumns: '56px minmax(0, 1fr) 128px',
      },
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '46px minmax(0, 1fr)',
      },
    }) as SxProps<Theme>,

  marker: (theme: Theme) =>
    ({
      gridColumn: 1,
      gridRow: 1,
      alignSelf: 'start',
      justifySelf: 'center',
      display: 'grid',
      placeItems: 'center',
      width: '24px',
      height: '24px',
      marginTop: '3px',
      borderRadius: '999px',
      background: '#8e9094',
      color: '#ffffff',
      fontSize: '14px',
      fontWeight: 800,
      [theme.breakpoints.down('sm')]: {
        width: '24px',
        height: '24px',
        marginTop: '3px',
        fontSize: '14px',
      },
    }) as SxProps<Theme>,

  content: (theme: Theme) =>
    ({
      gridColumn: '1 / -1',
      gridRow: 1,
      width: '100%',
      height: '100%',
      minWidth: 0,
      minHeight: 0,
      paddingLeft: '52px',
      paddingRight: '154px',
      [theme.breakpoints.down(980)]: {
        paddingLeft: '56px',
        paddingRight: '146px',
      },
      [theme.breakpoints.down('sm')]: {
        paddingLeft: '46px',
        paddingRight: '16px',
      },
    }) as SxProps<Theme>,

  title: (theme: Theme) =>
    ({
      margin: '4px 0 18px',
      color: '#111827',
      fontSize: '18px',
      fontWeight: 300,
      lineHeight: 1.22,
      [theme.breakpoints.down('sm')]: {
        fontSize: '18px',
      },
    }) as SxProps<Theme>,

  titleParagraph: () =>
    ({
      display: 'block',
      '& + &': {
        marginTop: '12px',
      },
    }) as SxProps<Theme>,

  titleStrong: () =>
    ({
      fontWeight: 700,
    }) as SxProps<Theme>,

  status: (theme: Theme) =>
    ({
      gridColumn: 3,
      gridRow: 1,
      alignSelf: 'stretch',
      display: 'flex',
      alignItems: 'flex-start',
      minHeight: '38px',
      padding: '1px 16px 0',
      background: '#eeeeee',
      [theme.breakpoints.down('sm')]: {
        gridColumn: 2,
        gridRow: 2,
        alignSelf: 'start',
        width: 'fit-content',
        marginTop: '14px',
        borderRadius: '8px',
        padding: '10px 14px',
        background: '#eeeeee',
      },
    }) as SxProps<Theme>,
};
